module.exports = [
  { id: '2', abbreviation: 'ABD', value: 'Aberdeenshire' },
  { id: '12', abbreviation: 'AGY', value: 'Anglesey' },
  { id: '22', abbreviation: 'ANS', value: 'Angus' },
  { id: '1072', abbreviation: 'ANT', value: 'Antrim' },
  { id: '32', abbreviation: 'ARL', value: 'Argyll & Bute' },
  { id: '1082', abbreviation: 'ARM', value: 'Armagh' },
  { id: '42', abbreviation: 'AVN', value: 'Avon' },
  { id: '52', abbreviation: 'BDF', value: 'Bedfordshire' },
  { id: '62', abbreviation: 'BRK', value: 'Berkshire' },
  { id: '1092', abbreviation: 'BGT', value: 'Blaenau Gwent' },
  { id: '82', abbreviation: 'BDG', value: 'Bridgend' },
  { id: '92', abbreviation: 'BKM', value: 'Buckinghamshire' },
  { id: '102', abbreviation: 'CPL', value: 'Caerphilly' },
  { id: '112', abbreviation: 'CAM', value: 'Cambridgeshire' },
  { id: '122', abbreviation: 'CDF', value: 'Cardiff' },
  { id: '132', abbreviation: 'CGN', value: 'Cardiganshire' },
  { id: '142', abbreviation: 'CMN', value: 'Carmarthenshire' },
  { id: '152', abbreviation: 'CHS', value: 'Cheshire' },
  { id: '162', abbreviation: 'CLK', value: 'Clackmannanshire' },
  { id: '172', abbreviation: 'CLV', value: 'Cleveland' },
  { id: '182', abbreviation: 'CWY', value: 'Conwy' },
  { id: '192', abbreviation: 'CON', value: 'Cornwall' },
  { id: '1112', abbreviation: 'DOW', value: 'Down' },
  { id: '202', abbreviation: 'CMA', value: 'Cumbria' },
  { id: '212', abbreviation: 'DEN', value: 'Denbighshire' },
  { id: '222', abbreviation: 'DBY', value: 'Derbyshire' },
  { id: '1102', abbreviation: 'DRY', value: 'Derry' },
  { id: '232', abbreviation: 'DEV', value: 'Devon' },
  { id: '242', abbreviation: 'DOR', value: 'Dorset' },
  { id: '252', abbreviation: 'DGY', value: 'Dumfries & Galloway' },
  { id: '262', abbreviation: 'DUR', value: 'Durham' },
  { id: '272', abbreviation: 'AYR', value: 'East Ayrshire' },
  { id: '292', abbreviation: 'DNB', value: 'East Dunbartonshire' },
  { id: '312', abbreviation: 'ELN', value: 'East Lothian' },
  { id: '322', abbreviation: 'ERF', value: 'East Renfrewshire' },
  { id: '1162', abbreviation: 'EYK', value: 'East Yorkshire' },
  { id: '342', abbreviation: 'ESS', value: 'Essex' },
  { id: '1122', abbreviation: 'FER', value: 'Fermanagh' },
  { id: '352', abbreviation: 'FIF', value: 'Fife' },
  { id: '362', abbreviation: 'FLN', value: 'Flintshire' },
  { id: '372', abbreviation: 'GLS', value: 'Gloucestershire' },
  { id: '1184', abbreviation: 'GSY', value: 'Guernsey' },
  { id: '72', abbreviation: 'GNT', value: 'Gwent' },
  { id: '402', abbreviation: 'GWN', value: 'Gwynedd' },
  { id: '412', abbreviation: 'HAM', value: 'Hampshire' },
  { id: '422', abbreviation: 'HEF', value: 'Herefordshire' },
  { id: '432', abbreviation: 'HRT', value: 'Hertfordshire' },
  { id: '442', abbreviation: 'HLD', value: 'Highland' },
  { id: '452', abbreviation: 'IVC', value: 'Inverclyde' },
  { id: '462', abbreviation: 'ISM', value: 'Isle of Man' },
  { id: '472', abbreviation: 'IOW', value: 'Isle of Wight' },
  { id: '1183', abbreviation: 'JRS', value: 'Jersey' },
  { id: '492', abbreviation: 'KEN', value: 'Kent' },
  { id: '502', abbreviation: 'LAN', value: 'Lancashire' },
  { id: '512', abbreviation: 'LEI', value: 'Leicestershire' },
  { id: '522', abbreviation: 'LIN', value: 'Lincolnshire' },
  { id: '302', abbreviation: 'LDE', value: 'London - East' },
  { id: '282', abbreviation: 'LEC', value: 'London - East Central' },
  { id: '652', abbreviation: 'LDN', value: 'London - North' },
  { id: '662', abbreviation: 'LNW', value: 'London - North West' },
  { id: '812', abbreviation: 'LSE', value: 'London - South East' },
  { id: '832', abbreviation: 'LSW', value: 'London - South West' },
  { id: '1152', abbreviation: 'LWT', value: 'London - West' },
  { id: '972', abbreviation: 'LWC', value: 'London - West Central' },
  { id: '532', abbreviation: 'GTM', value: 'Manchester, Greater' },
  { id: '542', abbreviation: 'MSY', value: 'Merseyside' },
  { id: '552', abbreviation: 'MTR', value: 'Merthyr' },
  { id: '382', abbreviation: 'MDX', value: 'Middlesex' },
  { id: '562', abbreviation: 'MLN', value: 'Midlothian' },
  { id: '572', abbreviation: 'MON', value: 'Monmouthshire' },
  { id: '582', abbreviation: 'MOR', value: 'Moray' },
  { id: '592', abbreviation: 'NPT', value: 'Neath & Port Talbot' },
  { id: '602', abbreviation: 'NWT', value: 'Newport' },
  { id: '612', abbreviation: 'NFK', value: 'Norfolk' },
  { id: '622', abbreviation: 'NAS', value: 'North Ayrshire' },
  { id: '632', abbreviation: 'LKS', value: 'North Lanarkshire' },
  { id: '642', abbreviation: 'NLS', value: 'North Lincolnshire' },
  { id: '672', abbreviation: 'NYS', value: 'North Yorkshire' },
  { id: '682', abbreviation: 'NTH', value: 'Northamptonshire' },
  { id: '692', abbreviation: 'NBL', value: 'Northumberland' },
  { id: '702', abbreviation: 'NTT', value: 'Nottinghamshire' },
  { id: '1185', abbreviation: 'ORK', value: 'Orkney' },
  { id: '712', abbreviation: 'OXF', value: 'Oxfordshire' },
  { id: '722', abbreviation: 'PEM', value: 'Pembrokeshire' },
  { id: '732', abbreviation: 'PKS', value: 'Perth & Kinross' },
  { id: '742', abbreviation: 'POW', value: 'Powys' },
  { id: '752', abbreviation: 'RFW', value: 'Renfrewshire' },
  { id: '762', abbreviation: 'RCT', value: 'Rhondda Cynon Taff' },
  { id: '772', abbreviation: 'SBS', value: 'Scottish Borders' },
  { id: '1172', abbreviation: 'SID', value: 'Shetland Islands' },
  { id: '782', abbreviation: 'SAL', value: 'Shropshire' },
  { id: '792', abbreviation: 'SOM', value: 'Somerset' },
  { id: '802', abbreviation: 'SAS', value: 'South Ayrshire' },
  { id: '822', abbreviation: 'SLS', value: 'South Lanarkshire' },
  { id: '842', abbreviation: 'SYK', value: 'South Yorkshire' },
  { id: '852', abbreviation: 'STS', value: 'Staffordshire' },
  { id: '862', abbreviation: 'STI', value: 'Stirlingshire' },
  { id: '872', abbreviation: 'STD', value: 'Strathclyde' },
  { id: '882', abbreviation: 'SFK', value: 'Suffolk' },
  { id: '892', abbreviation: 'SRY', value: 'Surrey' },
  { id: '902', abbreviation: 'SSX', value: 'Sussex' },
  { id: '912', abbreviation: 'SWS', value: 'Swansea' },
  { id: '922', abbreviation: 'TAY', value: 'Tayside' },
  { id: '932', abbreviation: 'TFN', value: 'Torfaen' },
  { id: '942', abbreviation: 'TWR', value: 'Tyne & Wear' },
  { id: '1132', abbreviation: 'TYR', value: 'Tyrone' },
  { id: '952', abbreviation: 'VGN', value: 'Vale of Glamorgan' },
  { id: '962', abbreviation: 'WAR', value: 'Warwickshire' },
  { id: '982', abbreviation: 'WDB', value: 'West Dunbartonshire' },
  { id: '1002', abbreviation: 'WLN', value: 'West Lothian' },
  { id: '1012', abbreviation: 'WMD', value: 'West Midlands' },
  { id: '1022', abbreviation: 'WYK', value: 'West Yorkshire' },
  { id: '1032', abbreviation: 'WIL', value: 'Wiltshire' },
  { id: '1042', abbreviation: 'WRL', value: 'Wirral' },
  { id: '1052', abbreviation: 'WOR', value: 'Worcestershire' },
  { id: '1062', abbreviation: 'WHM', value: 'Wrexham' },
];
